export enum pageRoute {
  gameMode = 'game-mode',
  gamePlan = 'game-plan',
}
